<template>
  <div class="ap-field">
    <label :for="inputId">{{ label }} <span v-if="required" class="ap-req">*</span></label>
    <div class="ap-input-wrap">
      <fa-icon :icon="['fas', 'envelope']" class="ap-lead" />
      <input
        :id="inputId"
        :value="value"
        type="email"
        :placeholder="placeholder"
        class="ap-input"
        :class="{ 'has-error': touched && value && !isValid }"
        @input="handleInput"
        @blur="touched = true"
      />
    </div>
    <span v-if="touched && value && !isValid" class="ap-err">
      <fa-icon :icon="['fas', 'exclamation-circle']" /> Invalid email address.
    </span>
    <span v-if="hint" class="ap-hint">{{ hint }}</span>
  </div>
</template>

<script>
export default {
  name: 'EmailInput',
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: 'Email' },
    required: { type: Boolean, default: false },
    placeholder: { type: String, default: 'client@company.com.my' },
    hint: { type: String, default: '' },
    inputId: { type: String, default: '' }
  },
  data () {
    return { touched: false }
  },
  computed: {
    isValid () {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.value)
    }
  },
  watch: {
    value (val) {
      if (val) this.touched = true
    }
  },
  methods: {
    handleInput (e) {
      this.touched = true
      this.$emit('input', e.target.value)
    }
  }
}
</script>
